module.exports = __webpack_public_path__ + "img/apiminer.6a752288.png";